import React, { useState } from "react";
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import IconX from '../../assets/X.png';
import { Link } from 'react-router-dom';
import Skilling01 from "../../assets/4XC/Screenshot_1.png";
import Skilling02 from "../../assets/4XC/Screenshot_2.png";
import Skilling03 from "../../assets/4XC/Screenshot_6.png";
import Skilling04 from "../../assets/4XC/Screenshot_7.png";
import Skilling05 from "../../assets/4XC/Screenshot_8.png";
import Skilling06 from "../../assets/4XC/Screenshot_9.png";
import Header from "../Header/Header2.js";
import PDFViewer from './PDFViewer.js';

const StyledLink = styled(Link)`
  color: white;
  text-decoration: none;
  font-weight: bold;
  margin-top: 1rem;

  &:hover {
    text-decoration: underline;
    filter: brightness(0.8);
  } 
`;

const StyledLink2 = styled(Link)`
  color: white;
  text-decoration: none;
  font-weight: bold;
  margin:1rem;
`;


const TitleSub2 = styled.button`
  width: 200px;
  height: 50px;
  background: none;
  cursor: pointer;
  font-weight: 600;
  color: white;
  font-size: 1.2rem;
  border-radius: 8px;
  border: 1px solid #FFC222;
  transition: 500ms;
  margin: 8px;

  &:hover{
    background: #FFC222;
  }
`;

const Fechar = styled.img``;

const Container = styled.div`
  background: #111111;
  padding: 2rem;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;


  @media (max-width: 1000px) {
    overflow-x: hidden !important;
  }
`;

const Title = styled.h1`
  text-align: center;
  width: 100%;
  color: white;
  font-size: 1.5rem;
  font-weight: 600;
  margin: 1rem;
`;

const TitleSub = styled.h1`
  text-align: center;
  width: 100%;
  color: #c3c3c3;
  font-size: 1.3rem;
  font-weight: 400;
  margin-bottom: 1rem;
`;

const Card = styled.div`
  width: 1080px;
  background: #151515;
  padding: 2rem;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  border-radius: 14px;
  margin: 2rem;
  position: relative;

  @media (max-width: 1000px) {
   width: 100%;
   max-width: 400px;
  }
`;

const Botao = styled.button`
  width: 250px;
  height: 50px;
  background: linear-gradient(to right, #aa7d3c, #f2cf8d);
  cursor: pointer;
  font-weight: 600;
  color: black;
  font-size: 1.2rem;
  border-radius: 8px;
  border: none;
  transition: 500ms;
  margin: 8px;

  &:hover{
    filter: brightness(0.8);
  }
`;

const Botao2 = styled.button`
  width: 250px;
  height: 50px;
  background: none;
  cursor: pointer;
  font-weight: 600;
  color: white;
  font-size: 1.2rem;
  border-radius: 8px;
  border: 1px solid white;
  transition: 500ms;
  margin: 8px;

  &:hover{
    filter: brightness(0.8);
  }
`;

const Image = styled.img`
  max-width: 100%;
  margin: 20px;
`;

const BolinhasContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 10px;
`;

const Bolinha = styled.div`
  width: 24px;
  height: 10px;
  border-radius: 14px;
  margin: 0 6px;
  cursor: pointer;
  background: ${(props) => (props.selected ? '#f2cf8d' : '#c3c3c3')};

  @media (max-width: 1000px) {
   width: 10px;
  }
`;

const TextPrincipal = styled.h1`
  color: transparent;
  background: linear-gradient(to right, #aa7d3c, #f2cf8d);
  -webkit-background-clip: text;
  margin-bottom: 1rem;
  text-align: center;
`;

const SubPrincipal = styled.p`
  color: white;
  font-size: 1.2rem;
  text-align: center;
`;

const Linkada = styled.a`
    width: 100%;
    text-align: center;
  color: transparent;
  margin: 0.5rem;
  transition: 500ms;
  font-size: 1.2rem;
  background: linear-gradient(to right, #aa7d3c, #f2cf8d);
  -webkit-background-clip: text;

  &:hover{
    filter: brightness(0.8);
  }
`;

const Linkada2 = styled.a`
  width: 100%;
  text-align: center;
  color: transparent;
  margin: 0.5rem;
  transition: 500ms;
  font-size: 1rem;
  background: linear-gradient(to right, #aa7d3c, #f2cf8d);
  -webkit-background-clip: text;

  &:hover{
    filter: brightness(0.8);
  }
`;


const Linkada3 = styled.a`
  width: 250px;
  padding: 1rem;
  text-align: center;
  color: white;
  margin: 0.5rem;
  transition: 500ms;
  font-size: 1rem;
  background: none;
  border: 1px solid white;
  border-radius: 10px;
  text-decoration: none;

  &:hover{
    filter: brightness(0.8);
  }
`;

const images = [ Skilling02, Skilling03 , Skilling04 , Skilling05, Skilling06];

function Site() {
    const { t } = useTranslation();
    const [currentImageIndex, setCurrentImageIndex] = useState(0);
  
    const nextImage = (index) => {
        setCurrentImageIndex((prevIndex) => (prevIndex + 1) % images.length);
    };

    const imageInfo = [
        {
            title: t('4XC.passo.2'),
            cont: t('skillingT01')
        },
      {
        title: t('4XC.invest.5'),
        cont: t('skillingT02')
      },
      {
        title: t('4XC.invest.6'),
        cont: t('skillingT03')
      },
      {
        title: t('4XC.invest.7'),
        cont: t('skillingT04')
      },
      {
        title: t('4XC.invest.8'),
        cont: t('skillingT05')
      },
    ];
    

    return (
        <Container>
            <Header/>
            <StyledLink to={t('back.language')}>
                <Fechar src={IconX} alt="Fechar"/>   
            </StyledLink>
            <Card>
                <TextPrincipal>{t('4XC.title')}</TextPrincipal>
                <Linkada href="https://br.trustpilot.com/" target="_blank">{t('trustpilot')}</Linkada>
                <SubPrincipal>{t('4xc.sub1')}</SubPrincipal>
                <Linkada2 href="https://live.4xc.com/signup/pqa1blmg" target="_blank">https://live.4xc.com/signup/pqa1blmg</Linkada2>
                <SubPrincipal>{t('4xc.pdf.title')}</SubPrincipal>
                <Linkada href="/4xc-beneficios" target="_blank">{t('card.button')}</Linkada>
                <Image src={images[currentImageIndex]} alt={`Skilling ${currentImageIndex + 1}`} />
                <BolinhasContainer>
                    {images.map((_, index) => (
                        <Bolinha
                            key={index}
                            selected={index === currentImageIndex}
                            onClick={() => setCurrentImageIndex(index)} // Alterado aqui
                        />
                    ))}
                </BolinhasContainer>
                <Title>{imageInfo[currentImageIndex].cont}</Title>
                <TitleSub>{imageInfo[currentImageIndex].title}</TitleSub>
                {currentImageIndex === 4 && (
                  <Linkada3 href="/deposito-4XC">
                     {t('depositoinfinox.button')}
                  </Linkada3>
                )}
                <Botao onClick={nextImage}>{t('next.button')}</Botao>
            </Card>
        </Container>
    );
}

export default Site;
